module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer047"
    }
  }, [_c('p', {
    staticClass: "CN ParaOverride-1",
    attrs: {
      "id": "_idParaDest-2",
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Also by Mark Bowden")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Doctor Dealer")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Bringing the Heat")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Black Hawk Down")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Killing Pablo")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Finders Keepers")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Road Work")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Guests of the Ayatollah")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Best Game Ever")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Worm")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Finish")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Three Battles of Wanat")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1868c60a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook_V45571.vue
// module id = 66
// module chunks = 0